import * as cx from 'classnames';
import AdSlot, { OwnProps as AdSlotProps } from 'mk2/containers/AdSlot/AdSlot';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { AppState } from 'mk2/reducers';
import * as React from 'react';
import { connect } from 'react-redux';
import styles from './AdSlotBranding.mscss';

interface OwnProps extends AdSlotProps {}

interface StateProps {
}

interface DispatchProps {

}

type Props = OwnProps;

class AdSlotBranding extends React.Component<Props> {

    public render() {
        const { zone, className, ...rest } = this.props;
        return (
            <div className={styles.AdSlotBranding}>
                <AdSlot className={cx(styles.AdSlotBranding__desktop, className)} {...rest} zone={`${zone} (Desktop)`} prefix="mk-branding" />
            </div>
        );
    }
}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    return {

    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
};

export default connect(mapStateToProps, mapDispatchToProps)(AdSlotBranding);
